import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import en from '@angular/common/locales/en';

import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';

import { routes } from './app.routes';
import { queryInterceptor } from './interceptors/interceptor';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([queryInterceptor])),
    provideNzI18n(en_US),
    provideNzDateFnsAdapter(),
  ],
};
